import { useEffect, useRef, useState } from "react";
import "../../styles/custom.css";

// ------ imports --------
import Feed from "../../components/organisms/Feed";
import { useAppSelector } from "../../redux/ReduxType";
import CreatePost from "../../components/shared/CreatePost";
import { POST_URL } from "../../constant/resource";
import { useFetchData } from "../../hooks/useFetchData";
import CustomLoader from "../../components/shared/PageLoader";
import Status from "../../components/organisms/status";
import { Post } from "../../type/post.type";
import { getAllPost } from "./data";
import { useDispatch } from "react-redux";
import { setPosts } from "../../redux/slice/post.slice";

// ------ imports --------

const Homepage = () => {
  const isDark = useAppSelector((state) => state?.theme?.isDark);
  // const posts = useAppSelector((state) => state?.posts.posts);
  const auth = useAppSelector((state) => state?.user);
  const userId: string | null = auth?._id;
  const dispatch = useDispatch();

  const {
    data: postData,
    loading: loadingPost,
    refetch,
  } = useFetchData<any>(POST_URL + "/all");

  // ----------- scroll --------------

  useEffect(() => {
    const fetchPosts = () => {
      const posts = getAllPost(postData);
      // console.log("posts", posts, "post data", postData);
      dispatch(setPosts(posts));
    };
    fetchPosts();
  }, [dispatch, postData]);

  const allPosts = useAppSelector((state) => state.posts.posts);
  // console.log("page posts -->", allPosts);

  if (loadingPost) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <CustomLoader
          type="round"
          color={isDark ? "#ffffff" : "#A028F8"}
          size={80}
        />
      </div>
    );
  }

  return (
    <div
      className={`mb-10 ${
        isDark ? "text-darkText" : " text-deepBg"
      } sm:p-5 p-3 custom-scrollbar`}
    >
      {/* status */}
      {auth?._id ? (
        <div className="sm:mb-5 mb-3">
          <Status />
        </div>
      ) : null}

      {/**----- Create a post ------ */}
      {userId ? <CreatePost refetch={refetch} userId={auth?._id} /> : null}

      {/**---- News feed ----- */}
      <section
        className={`text-xs mt-10 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}
      >
        {allPosts?.length > 0 ? (
          allPosts?.map((eachData: Post, index: number) => {
            return (
              <Feed
                showAll={false}
                isDark={isDark}
                refetch={refetch}
                data={eachData}
                key={index}
              />
            );
          })
        ) : (
          <p>No feed found</p>
        )}
      </section>
    </div>
  );
};

export default Homepage;
